// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"ListItem_cardBox__1iEzn","itemInfo":"ListItem_itemInfo__1oN-C","price":"ListItem_price__3W894","cardIndex":"ListItem_cardIndex__3oeQu"};